import React from 'react';

import { IKebabItem, KebabMenu } from '@r1-frontend/ui-react/components/KebabMenu';

import * as ST from './styled';

export type { IKebabItem };

export interface IKebabMenuProps {
    kebabMenuItems?: IKebabItem[],
    onSelectItem?: (item?: IKebabItem) => void,
    onClickMenu?: (menuStatus?: boolean) => void,
}

export const KebabMenuElement = ({
    kebabMenuItems,
    onClickMenu,
    onSelectItem,
} : IKebabMenuProps): JSX.Element => {
    if (!kebabMenuItems?.length || !onSelectItem) {
        return <></>;
    }

    return (
        <ST.KebabMenuElement>
            <KebabMenu
                menuItems={kebabMenuItems}
                onClickMenu={onClickMenu}
                onSelectMenu={onSelectItem}
            />
        </ST.KebabMenuElement>
    );
};
